import api from '../../auth/apiClient';
import { SAKTI_API_CONFIG } from '../apiConfig';
import {
  SaktiBccKpiResponse,
  SaktiBccListResponse,
  SaktiBccDetailResponse,
  SaktiBccHarvesterResponse,
  SaktiBaListResponse,
  SaktiBccImageDownloadRequest,
  SaktiFilters,
} from '../types';

const buildBccParams = (filters: SaktiFilters & { page?: number; limit?: number }) => {
  const params: Record<string, string | number> = {
    date: filters.date,
  };

  if (filters.company_id) params.company_id = filters.company_id;
  if (filters.estate_id) params.estate_id = filters.estate_id;
  if (filters.division_id) params.division_id = filters.division_id;
  if (filters.page) params.page = filters.page;
  if (filters.limit) params.limit = filters.limit;

  return params;
};

export class SaktiBccApiService {
  static async getKpi(filters: SaktiFilters): Promise<SaktiBccKpiResponse> {
    const response = await api.get<SaktiBccKpiResponse>(SAKTI_API_CONFIG.BCC_KPI_PATH, {
      params: buildBccParams(filters),
    });
    return response.data;
  }

  static async getList(filters: SaktiFilters & { page?: number; limit?: number }): Promise<SaktiBccListResponse> {
    const response = await api.get<SaktiBccListResponse>(SAKTI_API_CONFIG.BCC_LIST_PATH, {
      params: buildBccParams(filters),
    });
    return response.data;
  }

  static async getDetail(id: string): Promise<SaktiBccDetailResponse> {
    const response = await api.get<SaktiBccDetailResponse>(SAKTI_API_CONFIG.BCC_DETAIL_PATH(id));
    return response.data;
  }

  static async getRestan(filters: SaktiFilters & { page?: number; limit?: number }): Promise<SaktiBccListResponse> {
    const response = await api.get<SaktiBccListResponse>(SAKTI_API_CONFIG.BCC_RESTAN_PATH, {
      params: buildBccParams(filters),
    });
    return response.data;
  }

  static async getPerPemanen(filters: SaktiFilters): Promise<SaktiBccHarvesterResponse> {
    const response = await api.get<SaktiBccHarvesterResponse>(SAKTI_API_CONFIG.BCC_PER_PEMANEN_PATH, {
      params: buildBccParams(filters),
    });
    return response.data;
  }

  static async getBaList(filters: SaktiFilters & { page?: number; limit?: number }): Promise<SaktiBaListResponse> {
    const response = await api.get<SaktiBaListResponse>(SAKTI_API_CONFIG.BCC_BA_PATH, {
      params: buildBccParams(filters),
    });
    return response.data;
  }

  static async getBaRestan(filters: SaktiFilters & { page?: number; limit?: number }): Promise<SaktiBaListResponse> {
    const response = await api.get<SaktiBaListResponse>(SAKTI_API_CONFIG.BCC_BA_RESTAN_PATH, {
      params: buildBccParams(filters),
    });
    return response.data;
  }

  static async editBcc(id: string, payload: any): Promise<any> {
    const response = await api.patch(SAKTI_API_CONFIG.BCC_EDIT_PATH(id), payload);
    return response.data;
  }

  // Streams a ZIP; timeout disabled because large samples take longer than the axios default.
  static async downloadImages(payload: SaktiBccImageDownloadRequest): Promise<Blob> {
    const response = await api.post<Blob>(SAKTI_API_CONFIG.BCC_IMAGES_DOWNLOAD_PATH, payload, {
      responseType: 'blob',
      timeout: 0,
    });
    return response.data;
  }

  static async editBa(id: string, payload: any): Promise<any> {
    const response = await api.patch(SAKTI_API_CONFIG.BCC_BA_EDIT_PATH(id), payload);
    return response.data;
  }
}

export default SaktiBccApiService;
